export function updateImageUrl(url: string, width: number, height?: number): string {
  try {
    const parsedUrl = new URL(url)

    // Set or update width and height parameters
    parsedUrl.searchParams.set('width', width.toString())

    if (!!height) {
      parsedUrl.searchParams.set('height', height.toString())
    }

    return parsedUrl.toString()
  } catch (error) {
    console.error('Invalid URL:', error)
    return url // fallback in case the input URL is malformed
  }
}
